import { ISize } from '../components/mobile/slider/types';
import { INeighbourhoodSchema } from '../types';

export interface IParsedSlide {
  slide: string;
  description?: string;
  loaded: boolean;
  sizes?: ISize;
}

export interface IParsedSlides {
  previews: string[];
  slides: IParsedSlide[];
}

export const parseSlides = (slidesObject: INeighbourhoodSchema[]): IParsedSlides =>
  slidesObject.reduce(
    (acc, { thumbnailUrl = '', imageUrl = '', description = '' }) => ({
      previews: [...acc.previews, thumbnailUrl],
      slides: [
        ...acc.slides,
        {
          description,
          loaded: false,
          slide: imageUrl,
        },
      ],
    }),
    { previews: [], slides: [] },
  );
